import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

/**
 * NetworkErrorAlert component
 * Displays a network error message with a retry button
 */
const NetworkErrorAlert = ({ onRetry, isRetrying = false, message }) => {
  const errorMessage = message || 'Unable to connect to the server. Please check your internet connection and try again.';

  return (
    <div
      className="mb-6 p-4 bg-orange-500/10 border border-orange-500/30 rounded-xl"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <WifiOff className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
        <div className="flex-1">
          <p className="text-orange-400 text-sm font-medium mb-2">
            Connection Error
          </p>
          <p className="text-orange-300/80 text-sm mb-3">
            {errorMessage}
          </p>
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 hover:bg-orange-500/30 border border-orange-500/40 rounded-lg text-orange-300 text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label={isRetrying ? 'Retrying...' : 'Retry connection'}
          >
            <RefreshCw
              className={`w-4 h-4 ${isRetrying ? 'animate-spin' : ''}`}
              aria-hidden="true"
            />
            {isRetrying ? 'Retrying...' : 'Retry'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NetworkErrorAlert;
